var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.375L14 3.375L8 0.375V2.625H5.5C2.46243 2.625 0 5.08743 0 8.125C0 11.1626 2.46243 13.625 5.5 13.625H10.5C13.5376 13.625 16 11.1626 16 8.125C16 7.16589 15.7545 6.26413 15.3229 5.47911L13.9796 6.15075C14.3108 6.73324 14.5 7.40703 14.5 8.125C14.5 10.3341 12.7091 12.125 10.5 12.125H5.5C3.29086 12.125 1.5 10.3341 1.5 8.125C1.5 5.91586 3.29086 4.125 5.5 4.125H8V6.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.3c967cc0396a52d370d802f79b618e41.svg";
export { ForwardRef as ReactComponent };